import React from 'react'
import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  TableContainer,
  Td,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Select,
  Grid,
  GridItem,
  Input,
  Button,
  Flex,
  useToast,
} from '@chakra-ui/react'

import { Link, useParams } from 'react-router-dom'
import dayjs from 'dayjs'
import xhr from 'xhr'
import useAuth from 'hooks/useAuth'
import DatePicker from 'components/datePicker/DatePicker'
import { ChevronDownIcon } from '@chakra-ui/icons'

const statusList = [
  { value: 'nuevo', label: 'Nuevo' },
  { value: 'intentando_contactar', label: 'Intentando contactar' },
  { value: 'en_curso_tibio', label: 'En curso tibio' },
  { value: 'en_curso_caliente', label: 'En curso caliente' },
]

// allowTransfer=false: el módulo de asesoras reutiliza esta pantalla solo para buscar;
// allí la transferencia se hace desde el Escritorio, con motivo e historial.
function Prospectos({ allowTransfer = true }) {
  const [prospects, setProspects] = React.useState([])
  const [prospectReminders, setProspectReminders] = React.useState([])
  const [fetching, isFetching] = React.useState(false)
  const [dateFilter, setDateFilter] = React.useState(null)
  const [dateFilterEnd, setDateFilterEnd] = React.useState(null)
  const [filterState, setFilterState] = React.useState('')
  const [cellphone, setCellphone] = React.useState('')
  const [email, setEmail] = React.useState('')
  const [showFilter, setShowFilter] = React.useState(true)
  const [advisers, setAdvisers] = React.useState([])
  const [loadingFilter, setLoadingFilter] = React.useState(false)
  const [currentAdviser, setCurrentAdviser] = React.useState('')

  const toast = useToast()
  const { user } = useAuth()

  React.useEffect(() => {
    const fetchAdvisers = async () => {
      try {
        const resAdvisers = await xhr(`/advisers?filters[active][$eq]=true&populate=user`);
        setAdvisers(resAdvisers.data.data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchAdvisers();
  }, []);

  const handleTransfer = async (prospectId, newAdviserId) => {
    setLoadingFilter(true);
    try {
      await xhr.put(`/prospects/${prospectId}`, {
        data: {
          adviser: Number(newAdviserId),
        },
      });
      toast({
        title: 'Prospecto transferido',
        description: 'El prospecto ha sido transferido correctamente.',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
      handleFilter();
    } catch (error) {
      console.error('Error al transferir prospecto:', error);
      toast({
        title: 'Error',
        description: 'No se pudo transferir el prospecto.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoadingFilter(false);
    }
  };

  const handleFilter = async () => {
    if (!email && !cellphone && (!dateFilter || !dateFilterEnd)) {
      window.alert('Para buscar, debe ingresar un correo, un celular, o un rango de fechas completo.');
      return;
    }

    const params = new URLSearchParams();

    params.append('sort[0]', 'createdAt:desc');
    params.append('populate[0]', 'country');
    params.append('populate[1]', 'adviser.user');

    if (filterState) {
      params.append('filters[status][$eq]', filterState);
    }
    if (email) {
      params.append('filters[email][$eq]', email);
    }
    if (cellphone) {
      params.append('filters[cellphone][$eq]', cellphone);
    }
    if (dateFilter && dateFilterEnd) {
      const dateStart = dayjs(dateFilter).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
      const dateEnd = dayjs(dateFilterEnd).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
      params.append('filters[createdAt][$gte]', dateStart);
      params.append('filters[createdAt][$lte]', dateEnd);
    }

    try {
      isFetching(true);
      const finalUrl = `/prospects?${params.toString()}`;
      const res2 = await xhr(finalUrl);
      setProspects(
        res2.data.data.filter(
          (el) =>
            el.program !== 'convenio-referido' && el.program !== 'convenio-referido-fb'
        )
      );
    } catch (error) {
      console.error('Error al filtrar prospectos:', error);
    } finally {
      isFetching(false);
    }
  };

  const handleDateChange = (date) => {
    setDateFilter(date)
  }

  const handleDateChangeEnd = (date) => {
    setDateFilterEnd(date)
  }

  return (
    <>
      <Tabs>
        <TabList fontSize={{ default: '14px', md: '16px' }}>
          <Tab tabId="prospects" color="text200">
            Prospectos
          </Tab>
          <Tab tabId="reminders" color="text200">
            Recordatorios
          </Tab>
        </TabList>

        <TabPanels tabId="prospects" padding="major-2" paddingY="md">
          <TabPanel>

            <Box
              mb="20px"
              border={'1px solid gray'}
              w="30%"
              rounded="md"
              px="2px"
              display={'flex'}
              alignItems={'center'}
              justifyContent={'space-between'}
              cursor={'pointer'}
              onClick={() => setShowFilter(!showFilter)}
            >
              <Box>Aplicar filtro</Box> <ChevronDownIcon />
            </Box>


            {showFilter ? (
              <Grid templateColumns="repeat(5, 1fr)" gap={3}>
                <GridItem>
                  <Box>
                    <Box>Estado</Box>
                    <Select
                      mb="10px"
                      onChange={(e) => setFilterState(e.target.value)}
                    >
                      <option value="">Seleccione</option>
                      {statusList.map((el) => (
                        <option key={el.value} value={el.value}>
                          {el.label}
                        </option>
                      ))}
                    </Select>
                  </Box>
                </GridItem>
                <GridItem>
                  <Box>
                    <Box>Fecha Inicio</Box>
                    <DatePicker
                      date={dateFilter}
                      placeholder="Fecha inicio"
                      onChange={handleDateChange}
                    />
                  </Box>
                </GridItem>
                <GridItem>
                  <Box>
                    <Box>Fecha Fin</Box>
                    <DatePicker
                      date={dateFilterEnd}
                      placeholder="Fecha fin"
                      onChange={handleDateChangeEnd}
                    />
                  </Box>
                </GridItem>
                <GridItem>
                  <Box>
                    <Box>Celular</Box>
                    <Input
                      type="number"
                      placeholder="Celular"
                      value={cellphone}
                      onChange={(e) => setCellphone(e.target.value)}
                    />
                  </Box>
                </GridItem>
                <GridItem>
                  <Box>
                    <Box>Correo</Box>
                    <Input
                      placeholder="Correo"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </Box>
                </GridItem>
                <GridItem>
                  <Button colorScheme="messenger" onClick={handleFilter}>
                    Buscar
                  </Button>
                </GridItem>
              </Grid>
            ) : (
              ''
            )}

            <TableContainer maxH="75vh" overflowY="scroll">
              <Table variant="striped" colorScheme="blue">
                <Thead>
                  <Tr>
                    <Th textAlign="left">ID</Th>
                    <Th>Nombres</Th>
                    <Th>Email</Th>
                    <Th>Celular</Th>
                    <Th>Contactar por</Th>
                    <Th>Estado</Th>
                    <Th>Programa</Th>
                    <Th>Fecha Mat</Th>
                    <Th>Historial</Th>
                    <>
                      <Th>Asesora actual</Th>
                      {allowTransfer && <Th>Transferir a</Th>}
                    </>
                  </Tr>
                </Thead>
                <Tbody>
                  {fetching
                    ? 'cargando'
                    : prospects.map((prospect) => {
                      return (
                        <Tr key={prospect.id}>
                          <Td textAlign="left">{prospect.id}</Td>
                          <Td>
                            <Box whiteSpace="break-spaces" width="80px">
                              {prospect.name}
                            </Box>
                          </Td>
                          <Td>
                            <Box whiteSpace="break-spaces" width="130px">
                              {prospect.email}
                            </Box>
                          </Td>
                          <Td>
                            {prospect?.country
                              ? `+${prospect?.country?.phone_code}`
                              : ''}
                            {prospect.cellphone}
                          </Td>
                          <Td>{prospect.from}</Td>
                          <Td>
                            <Box whiteSpace="break-spaces" width="80px">
                              {prospect.status}
                            </Box>
                          </Td>
                          <Td>
                            <Box whiteSpace="break-spaces" width="150px">
                              {prospect.program}
                            </Box>
                          </Td>
                          <Td>
                            {dayjs(prospect.createdAt).format(
                              'DD-MM-YYYY h:mm A'
                            )}
                          </Td>
                          <Td>
                            <Link
                              to={`/plataforma/asesoras/ver-prospecto/${prospect.id}`}
                            >
                              <a>Ver </a>
                            </Link>
                          </Td>
                          <>
                            <Td>
                              <Box whiteSpace="break-spaces" width="150px">
                                {prospect.adviser?.user?.first_name}{' '}
                                {prospect.adviser?.user?.last_name}
                              </Box>
                            </Td>
                            {allowTransfer && (
                              <Td>
                                <Box whiteSpace="break-spaces" width="150px">
                                  <Select
                                    mb="10px"
                                    onChange={(e) => {
                                      handleTransfer(prospect.id, e.target.value);
                                    }}
                                  >
                                    <option value="">Seleccione</option>
                                    {advisers.map((el) => (
                                      <option key={el.id} value={el.id}>
                                        {el.user.email}
                                      </option>
                                    ))}
                                  </Select>
                                </Box>
                              </Td>
                            )}
                          </>
                        </Tr>
                      )
                    })}
                </Tbody>
              </Table>
            </TableContainer>
          </TabPanel>

          <TabPanel>
            <Box
              backgroundColor="white"
              borderRadius="10px"
              border="1px solid #9e46d8"
              marginRight="10px"
              mt="20px"
            >
              <Box
                color="white"
                backgroundColor="#574feb"
                borderTopRadius="8px"
                paddingLeft="10px"
                fontWeight="bold"
                fontSize="23px"
                paddingTop="10px"
                paddingBottom="10px"
              >
                Recordatorios para hoy
              </Box>

              <Box textAlign="center">
                <Table>
                  <Thead>
                    <Tr>
                      <Th>Nombres</Th>
                      <Th>Título</Th>
                      <Th>Mensaje</Th>
                      <Th>Estado Prospecto</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {fetching
                      ? 'cargando'
                      : prospectReminders.map((reminder) => {
                        return (
                          <Tr key={reminder.id}>
                            <Td textAlign="left">{reminder.prospect.name}</Td>
                            <Td>{reminder.title}</Td>
                            <Td>{reminder.message}</Td>
                            <Td>{reminder.prospect.status}</Td>
                          </Tr>
                        )
                      })}
                  </Tbody>
                </Table>
              </Box>
            </Box>
          </TabPanel>
        </TabPanels>
      </Tabs>

      <style>{`
        .bb-PaginationSelect {
          width: 100px;
        }
      `}</style>
    </>
  )
}

export default Prospectos